// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"confirmDragModal_inputContainer_2v6xV"};